import { postPublicRecognition } from "modules/Retention/services/retention";
import React from "react";
import { useSearchParams } from "react-router-dom";
import RecognitionForm from "../RecognitionForm";

function PublicRecognitionWrapper() {
  const [searchParams] = useSearchParams();

  const agencyId = +searchParams.get("agency_id") || "";
  const employeeId = +searchParams.get("employee_id") || "";

  const isUrlValid = agencyId && employeeId;

  return (
    <>
      {!isUrlValid ? (
        <div class="w-full flex items-center">
          <div
            class="w-full flex items-center justify-between bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
            role="alert"
          >
            <span class="block sm:inline">
              Invalid link. The url is missing required parameters.
            </span>
          </div>
        </div>
      ) : null}
      <div class="w-full h-full flex justify-center items-center">
        <RecognitionForm
          {...{
            employeeName: searchParams.get("employee_name") || "",
            jobTitle: searchParams.get("job_title") || "",
            employeeId,
            officeLocation: searchParams.get("office_location") || "",
            category: searchParams.get("recognition_category") || "",
            supervisor: searchParams.get("supervisor") || "",
            agencyId,
            agencyName: searchParams.get("agency_name") || "",
            recognizedById: +searchParams.get("recognized_by_id") || "",
          }}
          postRecognition={postPublicRecognition}
          disableSubmission={!isUrlValid}
        />
      </div>
    </>
  );
}

export default PublicRecognitionWrapper;